import React from 'react';
import { Helmet } from "react-helmet";
import { request } from '../../functions/apiRequestHelper';
import { gtmPageview } from '../../functions/gtm';
import smoothScroll from '../../functions/smoothScroll';
import API from '../../functions/api';
import queryString from 'query-string';
import Button from '../../audi-ui-components/Button';
import Layout from '../../components/Layout';
import Loader from '../../components/Loader';
import IconTime from '../../audi-ui-components/icons/Time';
import IconCalendar from '../../audi-ui-components/icons/CalendarEvents';
import IconAddressBook from '../../audi-ui-components/icons/AddressBook';
import DealerSearch from './DealerSearch';
import _find from 'lodash/find';
import {
    APPLICATION_CONTAINER_ID,
    UI_AUDI_MIN,
    UI_AUDI_DEALER,
    PATH_XTIME,
    PATH_XTIME_DEALER
} from '../../constants';
import './BookAService.scss';

import { connect } from 'react-redux';
const mapStateToProps = state => {
    return {
        currentDealer: state.dealers.current
    };
}

class BookAService extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dealerLocation: null,
            loading: true,
            isPredefinedDealer: false
        };
    }

    componentDidMount() {
        const { match } = this.props;
        if (this.props.currentDealer || match.params.dealer) {
            let dId = this.props.currentDealer?.dealerId || match.params.dealer;
            this.getData(dId, match.params.locationId, (loc) => {
              if (loc && loc !== null) {
                this.setState({dealerLocation: loc, loading: false, isPredefinedDealer: true});
              } else {
                // error?
                this.setState({loading: false});
              }
            });
        } else {
            this.setState({loading: false});
        }
        gtmPageview(this.props.location.pathname);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            smoothScroll.scrollTo(APPLICATION_CONTAINER_ID);
            gtmPageview(this.props.location.pathname);
        }
    }
    
    getData = (dId, locationId, cb) => {
      // console.log("getData", dId, locationId);
      this.setState({loading: true});
      const fields = `id
      locationId
      address
      latitude
      longitude
      mapsURL
      name
      phone
      postcode
      state
      suburb
      webKey
      dealer {
        name
        dealerCode
        phone
      }`;
      if (locationId) {
        API.post(
          process.env.RAZZLE_GQLAPI,
          {
            query: /* GraphQL */`query ($filter: LocationDtoFilterInput) {
              locationList(take: 1, where: $filter) {
                items {
                  ${fields}
                }
              }
            }`,
            variables: {
              filter: {locationId: {eq: parseInt(locationId)}, type: {eq: "Service"}, status: {eq: true}}
            }
          }
        ).then(response => {
            // console.log(response);
            let loc = response.data?.data?.locationList?.items[0];
            if ((!loc || loc === null) && dId) {
              // console.log("invalid location, try again");
              this.getData(dId, false, cb);
            } else {
              cb(response.data?.data?.location);
            }
        }).catch(error => {
            if (dId) {
              // console.log("invalid location, try again");
              this.getData(dId, false, cb);
            } else {
              cb(null);
            }
        });
      } else if (dId) {
        let gqlFilter = {type: {eq: "Service"}, status: {eq: true}};
        if (/^a[0-9]+$/.test(`${dId}`.toLowerCase())) {
          gqlFilter.dealerCode = {eq: dId};
        } else if (/^[0-9]+$/.test(dId)) {
          gqlFilter.dealer = {dealerId: {eq: parseInt(dId)}};
        } else {
          // invalid
          return cb(null);
        }
        API.post(
          process.env.RAZZLE_GQLAPI,
          {
            query: /* GraphQL */`query ($filter: LocationDtoFilterInput) {
              locationList(take: 1, where: $filter) {
                items {
                  ${fields}
                }
              }
            }`,
            variables: {
              filter: gqlFilter
            }
          }
        ).then(response => {
            // console.log(response);
            cb(response.data?.data?.locationList?.items[0]);
        }).catch(error => {
            cb(null);
        });
      }
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const {match, location, currentDealer} = this.props;
        const {dealerLocation, isPredefinedDealer, loading} = this.state;
        let showDealer = false;
        if ((currentDealer || match.params.dealer) && dealerLocation?.id) {
          showDealer = true;
        }
        return (
            <Layout ui={query.ui || UI_AUDI_MIN} theme="light" embedded={query.embedded}>
                <Helmet>
                    <title>Book a service | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page xtime">
                    
                    {loading && <Loader />}

                    {!showDealer && !loading && <div className="xtime-inner pt-3 pt-medium-5 pb-5">
                        <h1 className="aui-headline-2 mb-3 text-medium-center">Book a Service</h1>
                        <p className="aui-headline-6 mb-2 text-medium-center">Book a service appointment online or over the phone.</p>
                        <p className="aui-headline-6 mb-2 text-medium-center">The benefits of booking online include:</p>
                        <div className="d-flex flex-column flex-medium-row justify-content-center mb-5">
                          <span className="py-2 px-3"><IconTime small className="align-text-bottom" /> Select a time that suits you</span>
                          <span className="py-2 px-3"><IconCalendar small className="align-text-bottom" /> Add the booking to your calendar</span>
                          <span className="py-2 px-3"><IconAddressBook small className="align-text-bottom" /> Access and manage your booking</span>
                        </div>
                        <DealerSearch
                            history={this.props.history}
                            onSelectDealer={(loc) => {
                              // console.log("onSelectDealer");
                              this.setState({dealerLocation: loc});
                            }}
                        />
                    </div>}

                    {showDealer && <div className="selected-dealer xtime-inner pt-3 pt-medium-5 pb-5">
                        <div className="row mb-5">
                            <div className="d-none d-small-block col-12 col-medium">
                                <h2 className="aui-headline-4">{dealerLocation.name}</h2>
                                <p className="mb-3">{dealerLocation.address}, {dealerLocation.suburb} {dealerLocation.state} {dealerLocation.postcode}</p>
                            </div>
                            {!isPredefinedDealer && <div className="col-12 col-medium-auto">
                                <Button label="New search" buttonType="secondary" href={PATH_XTIME} />
                            </div>}
                        </div>
                        {this.state.dealerLocation.webKey && <div className="xtime-iframe-wrapper">
                            <iframe src={`https://connect.dealercell.com.au/online-tool/x-time-rego-lookup?webKey=${this.state.dealerLocation.webKey}&VARIANT=AUDI_AUSTRALIA&skipRedirect=true&WMODE=true&Dest=SERVICE&themeColor=%23000000`}  />
                        </div>}
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default connect(mapStateToProps)(BookAService);
